var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayButton = function SvgPlayButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 92,
    fill: "none",
    viewBox: "0 0 92 92"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 46,
    r: 46,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF0851",
    stroke: "#FF0851",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M39.664 37.653c0-1.295 0-1.942.27-2.3.235-.31.595-.503.984-.526.447-.027.985.333 2.063 1.05L57 45.226c.89.593 1.336.89 1.491 1.264.136.327.136.695 0 1.022-.155.374-.6.67-1.49 1.264L42.98 58.122c-1.078.718-1.616 1.078-2.063 1.05a1.33 1.33 0 0 1-.984-.526c-.27-.357-.27-1.004-.27-2.299z"
  })));
};
export default SvgPlayButton;